import { BrowserRouter, Routes, Route } from "react-router-dom";

import Institute from "./Institute";
import Welcome from "./Welcome";
import Lobby from "./Lobby";
import Reception from "./Reception";

import TutorRoom from "./TutorRoom";
import DoubtRoom from "./DoubtRoom";
import Dashboard from "./Dashboard";
import ProjectorRoom from "./ProjectorRoom";
import Register from "./Register";

/* MAIN COURSES */
import WebDevelopment from "./WebDevelopment";
import AIML from "./AIML";
import DataAnalytics from "./DataAnalytics";
import DataScience from "./DataScience";

/* EXTRA COURSES */
import AgenticAI from "./AgenticAI";
import ComputerVision from "./ComputerVision";
import PythonDSA from "./PythonDSA";
import AIEngineering from "./AIEngineering";

import About from "./About";
import Login from "./Login";

import Notes from "./Notes";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ENTRY FLOW */}
        <Route path="/" element={<Institute />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/lobby" element={<Lobby />} />
        <Route path="/reception" element={<Reception />} />
        <Route path="/register" element={<Register />} />

        {/* ROOMS */}
        <Route path="/classroom" element={<TutorRoom />} />
        <Route path="/tutor-room" element={<TutorRoom />} />
        <Route path="/doubt-room" element={<DoubtRoom />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/projector-room" element={<ProjectorRoom />} />

        {/* MAIN COURSES */}
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/ai-ml" element={<AIML />} />
        <Route path="/data-analytics" element={<DataAnalytics />} />
        <Route path="/data-science" element={<DataScience />} />

        {/* EXTRA COURSES */}
        <Route path="/agentic-ai" element={<AgenticAI />} />
        <Route path="/computer-vision" element={<ComputerVision />} />
        <Route path="/python-dsa" element={<PythonDSA />} />
        <Route path="/ai-engineering" element={<AIEngineering />} />

        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/notes" element={<Notes />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;
